module.exports = __webpack_public_path__ + "static/media/logMenuArrow.b5e329d5.svg";